/**
 * BCC France — JS entry point.
 *
 * Imports all feature modules and initialises them once the DOM is ready.
 * Compiled by Vite to assets/js/app.js (loaded by WordPress via functions.php).
 *
 * Source modules live alongside this file in assets/js/src/:
 *   mobile-menu.js     ← hamburger menu + submenu accordions
 *   toc.js             ← table-of-contents collapsible toggle
 *   header.js          ← sticky header scroll state + smooth scroll
 *   slider.js          ← horizontal card slider (prev / next)
 *   search.js          ← site search overlay
 *   hero-slideshow.js  ← hero image crossfade (home page only)
 *   highlight-slider.js ← featured information carousel with dot pagination
 */
import { initMobileMenu, initMobileSubmenus } from './mobile-menu.js';
import { initToc } from './toc.js';
import { initHeaderScroll, initSmoothScroll } from './header.js';
import { initSlider } from './slider.js';
import { initSearch } from './search.js';
import { initHeroSlideshow } from './hero-slideshow.js';
import { initLightbox } from './lightbox.js';
import { initCalendarSlider } from './calendar-slider.js';
import { initPwaInstall } from './pwa-install.js';
import { initEventTabs } from './event-tabs.js';
import { initHighlightSlider } from './highlight-slider.js';

document.addEventListener('DOMContentLoaded', () => {
  initMobileMenu();
  initMobileSubmenus();
  initToc();
  initHeaderScroll();
  initSmoothScroll();
  initSlider();
  initSearch();
  initHeroSlideshow();
  initLightbox();
  initCalendarSlider();
  initPwaInstall();
  initEventTabs();
  initHighlightSlider();
});
